module.exports = __webpack_public_path__ + "static/media/Get-Cash-for-Your-Car-in-Rocklea.fac0fed9.jpg";